// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { EnumMapRule, EnumMapRuleT, verifyEnumMapRule } from "./enum-map-rule";
import { EventKey, EventKeyT } from "./event-key";
import { FlagRule, FlagRuleT, verifyFlagRule } from "./flag-rule";
import { IgnoreRule, IgnoreRuleT, verifyIgnoreRule } from "./ignore-rule";
import { Origin } from "./origin";
import { RecordRule, RecordRuleT, verifyRecordRule } from "./record-rule";
import { Rule, unionToRule, unionListToRule } from "./rule";
import { TransformRule, TransformRuleT, verifyTransformRule } from "./transform-rule";
import { ValuedRule, ValuedRuleT, verifyValuedRule } from "./valued-rule";

export class EventRow implements flatbuffers.IUnpackableObject<EventRowT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): EventRow {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsEventRow(bb: flatbuffers.ByteBuffer, obj?: EventRow): EventRow {
    return (obj || new EventRow()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsEventRow(bb: flatbuffers.ByteBuffer, obj?: EventRow): EventRow {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new EventRow()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  key(obj?: EventKey): EventKey | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? (obj || new EventKey()).__init(this.bb_pos + offset, this.bb!) : null;
  }

  ruleType(): Rule {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : Rule.NONE;
  }

  rule<T extends flatbuffers.Table>(obj: any): any | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null;
  }

  text(): string | null;
  text(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  text(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  report(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  emergency(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  hidden(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  origin(): Origin {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : Origin.Unmapped;
  }

  line(): number {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  profileRow(): string | null;
  profileRow(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  profileRow(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  static startEventRow(builder: flatbuffers.Builder) {
    builder.startObject(10);
  }

  static addKey(builder: flatbuffers.Builder, keyOffset: flatbuffers.Offset) {
    builder.addFieldStruct(0, keyOffset, 0);
  }

  static addRuleType(builder: flatbuffers.Builder, ruleType: Rule) {
    builder.addFieldInt8(1, ruleType, Rule.NONE);
  }

  static addRule(builder: flatbuffers.Builder, ruleOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, ruleOffset, 0);
  }

  static addText(builder: flatbuffers.Builder, textOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, textOffset, 0);
  }

  static addReport(builder: flatbuffers.Builder, report: boolean) {
    builder.addFieldInt8(4, +report, +false);
  }

  static addEmergency(builder: flatbuffers.Builder, emergency: boolean) {
    builder.addFieldInt8(5, +emergency, +false);
  }

  static addHidden(builder: flatbuffers.Builder, hidden: boolean) {
    builder.addFieldInt8(6, +hidden, +false);
  }

  static addOrigin(builder: flatbuffers.Builder, origin: Origin) {
    builder.addFieldInt8(7, origin, Origin.Unmapped);
  }

  static addLine(builder: flatbuffers.Builder, line: number) {
    builder.addFieldInt32(8, line, 0);
  }

  static addProfileRow(builder: flatbuffers.Builder, profileRowOffset: flatbuffers.Offset) {
    builder.addFieldOffset(9, profileRowOffset, 0);
  }

  static endEventRow(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // key
    builder.requiredField(offset, 8); // rule
    return offset;
  }

  static createEventRow(
    builder: flatbuffers.Builder,
    keyOffset: flatbuffers.Offset,
    ruleType: Rule,
    ruleOffset: flatbuffers.Offset,
    textOffset: flatbuffers.Offset,
    report: boolean,
    emergency: boolean,
    hidden: boolean,
    origin: Origin,
    line: number,
    profileRowOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    EventRow.startEventRow(builder);
    EventRow.addKey(builder, keyOffset);
    EventRow.addRuleType(builder, ruleType);
    EventRow.addRule(builder, ruleOffset);
    EventRow.addText(builder, textOffset);
    EventRow.addReport(builder, report);
    EventRow.addEmergency(builder, emergency);
    EventRow.addHidden(builder, hidden);
    EventRow.addOrigin(builder, origin);
    EventRow.addLine(builder, line);
    EventRow.addProfileRow(builder, profileRowOffset);
    return EventRow.endEventRow(builder);
  }

  unpack(): EventRowT {
    return new EventRowT(
      this.key() !== null ? this.key()!.unpack() : null,
      this.ruleType(),
      (() => {
        const temp = unionToRule(this.ruleType(), this.rule.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })(),
      this.text(),
      this.report(),
      this.emergency(),
      this.hidden(),
      this.origin(),
      this.line(),
      this.profileRow(),
    );
  }

  unpackTo(_o: EventRowT): void {
    _o.key = this.key() !== null ? this.key()!.unpack() : null;
    _o.ruleType = this.ruleType();
    _o.rule = (() => {
      const temp = unionToRule(this.ruleType(), this.rule.bind(this));
      if (temp === null) {
        return null;
      }
      return temp.unpack();
    })();
    _o.text = this.text();
    _o.report = this.report();
    _o.emergency = this.emergency();
    _o.hidden = this.hidden();
    _o.origin = this.origin();
    _o.line = this.line();
    _o.profileRow = this.profileRow();
  }

  unpackFields(...fields: string[]): EventRowT {
    const t = new EventRowT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("key")) {
      t.key = this.key() !== null ? this.key()!.unpack() : null;
    }
    if (fieldSet.has("rule_type")) {
      t.ruleType = this.ruleType();
    }
    if (fieldSet.has("rule")) {
      t.rule = (() => {
        const temp = unionToRule(this.ruleType(), this.rule.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })();
    }
    if (fieldSet.has("text")) {
      t.text = this.text();
    }
    if (fieldSet.has("report")) {
      t.report = this.report();
    }
    if (fieldSet.has("emergency")) {
      t.emergency = this.emergency();
    }
    if (fieldSet.has("hidden")) {
      t.hidden = this.hidden();
    }
    if (fieldSet.has("origin")) {
      t.origin = this.origin();
    }
    if (fieldSet.has("line")) {
      t.line = this.line();
    }
    if (fieldSet.has("profile_row")) {
      t.profileRow = this.profileRow();
    }
    return t;
  }
}

export class EventRowT implements flatbuffers.IGeneratedObject {
  constructor(
    public key: EventKeyT | null = null,
    public ruleType: Rule = Rule.NONE,
    public rule:
      | EnumMapRuleT
      | FlagRuleT
      | IgnoreRuleT
      | RecordRuleT
      | TransformRuleT
      | ValuedRuleT
      | null = null,
    public text: string | Uint8Array | null = null,
    public report: boolean = false,
    public emergency: boolean = false,
    public hidden: boolean = false,
    public origin: Origin = Origin.Unmapped,
    public line: number = 0,
    public profileRow: string | Uint8Array | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.key === null || this.key === undefined) {
      throw new Error('Required field "key" is not set');
    }
    if (this.rule === null || this.rule === undefined) {
      throw new Error('Required field "rule" is not set');
    }
    const rule = builder.createObjectOffset(this.rule);
    const text = this.text !== null ? builder.createString(this.text!) : 0;
    const profileRow = this.profileRow !== null ? builder.createString(this.profileRow!) : 0;

    return EventRow.createEventRow(
      builder,
      this.key !== null ? this.key!.pack(builder) : 0,
      this.ruleType,
      rule,
      text,
      this.report,
      this.emergency,
      this.hidden,
      this.origin,
      this.line,
      profileRow,
    );
  }

  clone(): EventRowT {
    const obj = new EventRowT();
    obj.key = this.key !== null ? this.key!.clone() : null;
    obj.ruleType = this.ruleType;
    obj.rule =
      this.rule !== null && typeof (this.rule as any).clone === "function"
        ? (this.rule as any).clone()
        : this.rule;
    obj.text = this.text;
    obj.report = this.report;
    obj.emergency = this.emergency;
    obj.hidden = this.hidden;
    obj.origin = this.origin;
    obj.line = this.line;
    obj.profileRow = this.profileRow;
    return obj;
  }

  equals(other: EventRowT): boolean {
    if (this.key !== null && other.key !== null) {
      if (!this.key!.equals(other.key!)) return false;
    } else if (this.key !== other.key) return false;
    if (this.ruleType !== other.ruleType) return false;
    if (this.rule !== null && other.rule !== null) {
      if (typeof (this.rule as any).equals === "function") {
        if (!(this.rule as any).equals(other.rule)) return false;
      } else if (this.rule !== other.rule) return false;
    } else if (this.rule !== other.rule) return false;
    if (this.text !== other.text) return false;
    if (this.report !== other.report) return false;
    if (this.emergency !== other.emergency) return false;
    if (this.hidden !== other.hidden) return false;
    if (this.origin !== other.origin) return false;
    if (this.line !== other.line) return false;
    if (this.profileRow !== other.profileRow) return false;
    return true;
  }
}

export function verifyEventRow(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 8);
    verifier.checkRequiredField(tablePos, 4, "key");
    verifier.checkScalarField(tablePos, 6, 1);
    verifier.checkUnionConsistency(tablePos, 6, 8, "rule");
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        const uType = verifier.readFieldUint8(tablePos, 6);
        switch (uType) {
          case 1: // IgnoreRule
            {
              const o = verifier.readInt32(pos);
              verifyIgnoreRule(verifier, pos + o);
            }
            break;
          case 2: // FlagRule
            {
              const o = verifier.readInt32(pos);
              verifyFlagRule(verifier, pos + o);
            }
            break;
          case 3: // ValuedRule
            {
              const o = verifier.readInt32(pos);
              verifyValuedRule(verifier, pos + o);
            }
            break;
          case 4: // EnumMapRule
            {
              const o = verifier.readInt32(pos);
              verifyEnumMapRule(verifier, pos + o);
            }
            break;
          case 5: // RecordRule
            {
              const o = verifier.readInt32(pos);
              verifyRecordRule(verifier, pos + o);
            }
            break;
          case 6: // TransformRule
            {
              const o = verifier.readInt32(pos);
              verifyTransformRule(verifier, pos + o);
            }
            break;
        }
      }
    }
    verifier.checkRequiredField(tablePos, 8, "rule");
    {
      const pos = verifier.checkOffsetField(tablePos, 10);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 12, 1);
    verifier.checkScalarField(tablePos, 14, 1);
    verifier.checkScalarField(tablePos, 16, 1);
    verifier.checkScalarField(tablePos, 18, 1);
    verifier.checkScalarField(tablePos, 20, 4);
    {
      const pos = verifier.checkOffsetField(tablePos, 22);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
